/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
    Create,
    Edit,
    required,
    SimpleForm,
    TextInput,
    useNotify,
    useRefresh,
    useRedirect,
} from 'react-admin'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import BackButton from '../../components/BackButton'
import Title from '../../components/Title/Title'
import CustomCheckbox from '../../components/CustomCheckbox/CustomCheckbox'
import '../style.css'
import CustomValidater from '../../components/Utility/Validater'

const EducationComponent = (props) => {
    const user = useSelector((state) => state.auth)
    const userData = {
        created_by: user.description,
        modified_by: user.description,
    }
    const { isEdit, title, record } = props

    return (
        <SimpleForm
            validate={(values) => CustomValidater(values, props)}
            style={{ width: '100%' }}
            {...{ ...props, record: { ...record, ...userData } }}
            variant="outlined"
            warnWhenUnsavedChanges
            initialValues={userData}
        >
            <Title title={title} />
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Code"
                    source="code"
                    validate={[required()]}
                    disabled={isEdit}
                />
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Description"
                    source="description"
                    validate={required()}
                />
            </div>

            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Created By"
                    source="created_by"
                    validate={required()}
                />
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Modified By"
                    source="modified_by"
                    validate={required()}
                />
            </div>
            <div className="container">
                <div style={{ display: 'flex', flex: 1 }}>
                    <CustomCheckbox label="Technical" source="is_technical" />
                </div>
            </div>
        </SimpleForm>
    )
}

export default function CreateEducation(props) {
    const notify = useNotify()
    const refresh = useRefresh()
    const redirect = useRedirect()
    const { isEdit } = props
    const onSuccess = () => {
        notify(`Changes saved`, { type: 'success' })
        redirect('/PY_EducationTAB')
        refresh()
    }
    if (isEdit)
        return (
            <>
                <BackButton path="/PY_EducationTAB" />
                <Edit {...props} undoable={false}>
                    <EducationComponent title="Edit Education" isEdit />
                </Edit>
            </>
        )
    return (
        <>
            <BackButton path="/PY_EducationTAB" />
            <Create onSuccess={onSuccess} {...props}>
                <EducationComponent title="Create Education" isEdit={false} />
            </Create>
        </>
    )
}

CreateEducation.propTypes = {
    isEdit: PropTypes.bool.isRequired,
}

EducationComponent.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    record: PropTypes.objectOf(PropTypes.any).isRequired,
}
